import { cn } from '@/lib/core';
import type { ScreenHeadProps } from '@/lib/core/types';
import { Icon } from '@/components/ui/icon';
import { Heading } from '@/components/ui/heading';
import { useUIStore } from '@/lib/core/stores/useUIStore';

export function ScreenHead(props: ScreenHeadProps) {
  const override = useUIStore(state => state.screenHeadOverride);

  const {
    title,
    titleSuffix,
    onBack,
    ariaLabel = 'Go back',
    variant = 'default',
    rightActions,
    className,
    backIcon = 'long-arrow-up-left',
  } = { ...props, ...override };
  const isOverlay = variant === 'overlay';

  return (
    <div className={cn('relative flex w-full items-center px-4 py-2', isOverlay && 'z-999', className)}>
      {onBack && (
        <button
          type="button"
          aria-label={ariaLabel}
          className="relative z-10 flex size-11 shrink-0 items-center justify-center"
          onClick={onBack}
        >
          <Icon
            name={backIcon}
            width={24}
            height={24}
            strokeWidth={2}
            className={isOverlay ? 'text-white' : 'text-jncquoi-neutral-1000'}
          />
        </button>
      )}
      <Heading
        as="h1"
        className={cn(
          'font-pp-neue-montreal pointer-events-none absolute inset-x-0 text-center text-[14px] font-normal text-nowrap uppercase',
          isOverlay ? 'text-white' : 'text-jncquoi-neutral-1000'
        )}
      >
        {title}
        {titleSuffix && (
          <span className={isOverlay ? 'text-white/50' : 'text-jncquoi-neutral-400'}>
            {` ${titleSuffix}`}
          </span>
        )}
      </Heading>
      <div className="relative z-10 ml-auto shrink-0">{rightActions ?? <div className="size-11" />}</div>
    </div>
  );
}
